import { render, staticRenderFns } from "./RescueReport.vue?vue&type=template&id=0c227e4f"
import script from "./RescueReport.vue?vue&type=script&lang=js"
export * from "./RescueReport.vue?vue&type=script&lang=js"
import style0 from "./RescueReport.vue?vue&type=style&index=0&id=0c227e4f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports